export { DatePickerModule } from './date-picker.module';

export {DatePickerComponent} from './components/date-picker-component/date-picker-component';
//# sourceMappingURL=index.js.map